import React from 'react';
import {
  formatPhoneForDisplay,
  getBusinessAddress,
  getBusinessEmail,
  getBusinessPhone,
  getPhoneTelHref
} from '../../utils/contactInfo';
import { LANDING_PAGE_TYPES } from '../../utils/custom-pages/pageConfig';

const CustomerCustomPageContent = ({ companyData, page }) => {
  if (page.type === LANDING_PAGE_TYPES.CONTACT) {
    const phone = page.contactFields?.phone || getBusinessPhone(companyData);
    const email = page.contactFields?.email || getBusinessEmail(companyData);
    const address = page.contactFields?.address || getBusinessAddress(companyData);

    return (
      <div className="content-shell contact-shell">
        <div className="contact-card">
          {phone && (
            <div className="contact-row">
              <strong className="contact-label">Phone:</strong>
              <a href={getPhoneTelHref(phone)} className="contact-link">
                {formatPhoneForDisplay(phone)}
              </a>
            </div>
          )}

          {email && (
            <div className="contact-row">
              <strong className="contact-label">Email:</strong>
              <a href={`mailto:${email}`} className="contact-link">{email}</a>
            </div>
          )}

          {address && (
            <div className="contact-row">
              <strong className="contact-label">Address:</strong>
              <span className="contact-value">{address}</span>
            </div>
          )}

          {!phone && !email && !address && (
            <div className="contact-row">
              <span className="contact-value">Contact information will be available here soon.</span>
            </div>
          )}
        </div>
      </div>
    );
  }

  const content = page.content || 'This page will be updated soon.';

  return (
    <div className="content-shell">
      <div className="rich-text-content">
        {content}
      </div>
    </div>
  );
};

export default CustomerCustomPageContent;
